// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const DocumentManagementPage = lazy(() => import('./pages/DocumentManagementPage'));
const ESignaturePage = lazy(() => import('./pages/ESignaturePage'));
const OcrExtractionPage = lazy(() => import('./pages/OcrExtractionPage'));
const KnowledgeBasePage = lazy(() => import('./pages/KnowledgeBasePage'));
const AiSummarizationPage = lazy(() => import('./pages/AiSummarizationPage'));
const PublicSignerPage = lazy(() => import('./pages/PublicSignerPage'));

export const DocumentsRoutes: RouteObject = {
  path: 'documents',
  element: <ModuleGuard moduleId="core.documents" />,
  children: [
    { path: 'document-management', element: <DocumentManagementPage />, handle: { crumb: 'Document Management' } },
    { path: 'e-signature', element: <ESignaturePage />, handle: { crumb: 'E-Signature' } },
    { path: 'ocr-extraction', element: <OcrExtractionPage />, handle: { crumb: 'OCR & AI Extraction' } },
    { path: 'knowledge-base', element: <KnowledgeBasePage />, handle: { crumb: 'Knowledge Base' } },
    { path: 'ai-summarization', element: <AiSummarizationPage />, handle: { crumb: 'AI Summarization' } },
    { path: 'public-sign/:token', element: <PublicSignerPage />, handle: { crumb: 'Public Signature' } },
  ],
};
